import { render, staticRenderFns } from "./CreditCardTable.vue?vue&type=template&id=84987738"
import script from "./CreditCardTable.vue?vue&type=script&lang=js"
export * from "./CreditCardTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports